<template>
  <div>
    <v-layout row style="margin:0;">
      <v-flex xs6>
        <v-btn style="margin-bottom:10px;" @click="goBack" text>
          <i style="margin-right: 10px;" class="fal fa-chevron-left"></i>
          <span>{{ $t("detailtask.back") }}</span>
        </v-btn>
      </v-flex>
      <v-flex xs6 style="text-align:right;">
        <v-btn style="margin-bottom:10px;" @click="editTask" text>
          <i class="fal fa-pencil" style="margin-right: 10px;"></i>
          <span>{{ $t("detailtask.edit") }}</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap style="margin-left:0;margin-right:0;">
      <v-flex md6 lg6 sm12 xs12 style="padding:5px;">
        <v-card v-if="loaded">
          <v-card-title>{{ name }}</v-card-title>
          <v-card-text>
            <v-layout style="margin:0;" row wrap>
              <v-flex sm6>
                <p>{{ description }}</p>
              </v-flex>
              <v-flex sm6>
                <p>
                  <b>{{ $t("detailtask.interval") }}</b>
                  <br />
                  {{ getIntervalText(interval) }}
                </p>
                <p v-if="!never_done">
                  <b>{{ $t("detailtask.next_execution") }}</b>
                  <br />
                  {{ parseDateTime(next_time) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn :loading="l_mark_as_done" :disabled="l_mark_as_done" color="primary" @click="() => { !l_mark_as_done ? markAsDone() : ''}" text>
              <i class="fal fa-check" style="margin-right:5px;"></i>{{ $t("detailtask.now") }}
            </v-btn>
            <v-btn color="primary" @click="markAsDoneLaterDialog = true" text>
              <i class="fal fa-clock" style="margin-right:5px;"></i>{{ $t("detailtask.on_specific_time") }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <v-skeleton-loader class="mx-auto" width="100%" type="heading"></v-skeleton-loader>
          </v-card-title>
          <v-card-text>
            <v-skeleton-loader
              class="mx-auto"
              width="100%"
              style="margin:0;"
              v-for="n in 3"
              :key="n"
              type="text"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
        <v-card style="margin-top:20px;">
          <v-card-title>{{ $t("detailtask.progress") }}</v-card-title>
          <v-card-text>
            <v-layout row wrap style="margin:0;" v-if="!never_done">
              <v-flex xs12 sm6 style="text-align:center;padding-bottom:30px;">
                <v-progress-circular
                  :value="nextExecutionProgress"
                  size="120"
                  :rotate="270"
                  :color="done ? 'success' : 'primary'"
                  :indeterminate="!loaded_progress"
                >
                  <span
                    v-if="loaded_progress && nextExecutionProgress < 100"
                  >{{ (Math.round(nextExecutionProgress * 10) / 10).toFixed(1) }} %</span>
                  <span v-else-if="loaded_progress && done">100 %</span>
                </v-progress-circular>
              </v-flex>
              <v-flex xs12 sm6 v-if="loaded_progress">
                <p v-show="!done">
                  <b>{{ $t("detailtask.time_until_next_execution") }}</b>
                  <br />
                  <span>{{ timeUntilNextTime }}</span>
                </p>
                <p>
                  <b>{{ $t("detailtask.time_since_last_execution") }}</b>
                  <br />
                  <span>{{ timeSinceLastExecution }}</span>
                </p>
              </v-flex>
              <v-flex xs12 sm6 v-else>
                <v-skeleton-loader
                  class="mx-auto"
                  width="100%"
                  style="margin:10px;"
                  v-for="n in 4"
                  :key="n"
                  type="text"
                ></v-skeleton-loader>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex sm12>
                <p>{{ $t("detailtask.task_never_run") }}</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md6 lg6 sm12 xs12 style="padding:5px;">
        <div style="height:20px;width:100%;" class="d-flex d-md-none"></div>
        <v-card v-if="loaded_history">
          <v-card-title>{{ $t("detailtask.history") }} ({{ total_history }})</v-card-title>
          <v-card-text v-if="!never_done">
            <v-list dense>
              <v-list-item
                @click="deleteHistoryItem(item.id)"
                v-for="item in history"
                :key="item.id"
              >{{ parseDateTime(item.data.time) }}</v-list-item>
            </v-list>
            <v-btn
              :loading="load_more_history"
              v-if="!hide_load_more_history"
              @click="loadMoreHistory"
              text
            >{{ $t("detailtask.load_more") }}</v-btn>
          </v-card-text>
          <v-card-text v-else>
            <p>{{ $t("detailtask.no_history_available") }}</p>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title>{{ $t("detailtask.history") }}</v-card-title>
          <v-card-text>
            <v-skeleton-loader
              class="mx-auto"
              width="100%"
              style="margin:10px;"
              v-for="n in 5"
              :key="n"
              type="text"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn
      @click="archiveTask"
      v-if="!archived"
      height="50px"
      color="default"
      style="margin:5px;margin-top:20px;width:calc(100% - 10px)"
    >
      <i style="margin-right:5px;" class="fal fa-inbox-in"></i>{{ $t("detailtask.archive_task") }}
    </v-btn>
    <v-btn
      @click="unarchiveTask"
      v-else
      height="50px"
      color="default"
      style="margin:5px;margin-top:20px;width:calc(100% - 10px)"
    >
      <i style="margin-right:5px;" class="fal fa-inbox-out"></i>{{ $t("detailtask.unarchive_task") }}
    </v-btn>
    <v-btn
      @click="deleteTask"
      height="50px"
      color="error"
      style="margin:5px;margin-top:5px;width:calc(100% - 10px)"
    >
      <i style="margin-right:5px;" class="fal fa-trash"></i>{{ $t("detailtask.delete_task") }}
    </v-btn>
    <v-dialog v-model="markAsDoneLaterDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t("detailtask.mark_as_done") }}</v-card-title>
        <v-card-text style="text-align:center;">
          <v-date-picker :allowed-dates="allowedDates" v-if="markAsDoneLaterStep === 1" v-model="markAsDone_date"></v-date-picker>
          <v-time-picker :allowed-hours="allowedHours" format="24hr" v-if="markAsDoneLaterStep === 2" v-model="markAsDone_time"></v-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text v-if="markAsDoneLaterStep === 2" @click="markAsDoneLaterStep = 1">{{ $t("detailtask.back") }}</v-btn>
          <v-btn color="primary" text @click="() => {markAsDoneLaterStep === 2 ? markAsDoneOnSpecifcTime() : markAsDone_date ? markAsDoneLaterStep = 2 : markAsDoneLaterStep = 1}">{{ markAsDoneLaterStep === 1 ? $t("detailtask.next") : $t("detailtask.set") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { storage, s_messaging } from "../schmucklicloud";
import { Notifications } from "../notification";
import intervals from "../assets/data/intervals";

export default {
  data() {
    return {
      loaded: false,
      loaded_progress: false,
      loaded_history: false,
      l_mark_as_done: false,

      load_more_history: false,
      hide_load_more_history: false,

      never_done: false,

      id: 0,

      markAsDoneLaterDialog: false,
      markAsDoneLaterStep: 1,
      markAsDone_time: "00:00",
      markAsDone_date: undefined,

      current_time: 0,
      next_time: 0,
      last_time: 0,

      name: "...",
      description: "...",
      interval: "",
      archived: false,
      current_request_id: undefined,

      history: [],
      total_history: "..."
    };
  },
  mounted() {
    this.id = parseInt(this.$route.params.id);

    if (this.id === 0) {
      this.$router.replace("/");
    } else {
      this.initialize();
      this.loadHistory(0, 5);
      this.loadCountHistory();
    }
  },
  computed: {
    done() {
      return this.nextExecutionProgress >= 100 && this.l_last_done;
    },
    nextExecutionProgress() {
      var q = Math.abs(this.current_time - this.last_time);
      var d = Math.abs(this.next_time - this.last_time);

      return (q / d) * 100;
    },
    timeUntilNextTime() {
      var time = this.next_time - this.current_time;

      var days = Math.floor(time / 1000 / 60 / 60 / 24);
      var hours = Math.floor(time / 1000 / 60 / 60) - days * 24;
      var minutes = Math.floor(time / 1000 / 60) - hours * 60 - days * 24 * 60;
      var seconds = Math.floor(time / 1000) - minutes * 60 - hours * 60 * 60 - days * 24 * 60 * 60;

      return (
        days +
        " " + this.$t("detailtask.days") + ", " +
        hours +
        " " + this.$t("detailtask.hours") + ", " +
        minutes +
        " " + this.$t("detailtask.minutes") + ", " +
        seconds +
        " " + this.$t("detailtask.seconds")
      );
    },
    timeSinceLastExecution() {
      var time = this.current_time - this.last_time;

      var days = Math.floor(time / 1000 / 60 / 60 / 24);
      var hours = Math.floor(time / 1000 / 60 / 60) - days * 24;
      var minutes = Math.floor(time / 1000 / 60) - hours * 60 - days * 24 * 60;
      var seconds = Math.floor(time / 1000)- minutes * 60 - hours * 60 * 60 - days * 24 * 60 * 60;

      return (
        days +
        " " + this.$t("detailtask.days") + ", " +
        hours +
        " " + this.$t("detailtask.hours") + ", " +
        minutes +
        " " + this.$t("detailtask.minutes") + ", " +
        seconds +
        " " + this.$t("detailtask.seconds")
      );
    }
  },
  methods: {
    async initialize() {
      await this.getDetails();
      await this.getNextExecution();
    },
    async getDetails() {
      var response = await storage.getById("tasks", this.id);
      if (response.isOK) {
        var data = response.data.data;
        this.name = data.name;
        this.description = data.description;
        this.interval = data.interval;
        this.current_request_id = data.current_request_id;
        this.archived = data.archived || false;

        this.loaded = true;
      } else {
        Notifications.show(
          "There was an error while trying to fetch details for this task."
        );
        this.$router.replace("/");
      }
    },
    async getNextExecution() {
      this.current_time = new Date().getTime();
      this.last_time = parseInt((await this.getLastDone()).data.time);
      this.next_time = this.last_time + this.interval * 1000;

      this.loaded_progress = true;

      clearInterval(this.timer_current_time);
      this.timer_current_time = setInterval(
        function() {
          this.current_time = new Date().getTime();
        }.bind(this),
        100
      );
    },
    getIntervalText(value) {
      var text;
      intervals.forEach(function(interval) {
        if (interval.value == value) {
          text = interval.text;
        }
      });
      return this.$t(text);
    },
    async loadHistory(start, end, reset) {
      if (reset) {
        this.loadCountHistory();
      }
      
      var response = await storage.get(
        "dones",
        [
          {
            column: "task_id",
            operator: "==",
            value: this.id
          }
        ],
        {
          column: "time",
          order: "desc"
        },
        start,
        end
      );
      this.loaded_history = true;
      if (response.isOK) {
        if (reset) {
          this.history = [];
        }
        if (response.data !== undefined) {
          this.history = this.history.concat(response.data);
        } else {
          this.hide_load_more_history = true;
        }

        if (this.history.length === 0) {
          this.never_done = true;
        }
      } else {
        Notifications.show(response.message);
      }
    },
    async loadMoreHistory() {
      this.load_more_history = true;
      await this.loadHistory(this.history.length, 5);
      this.load_more_history = false;
    },
    async loadCountHistory() {
      var response = await storage.count("dones", [{
        column: "task_id",
        operator: "==",
        value: this.id
      }]);
      if (response.isOK) {
        this.total_history = response.data.count;
      }
    },
    editTask() {
      this.$router.push("/task/" + this.id + "/edit");
    },
    async archiveTask() {
      var response = await storage.update("tasks", this.id, {
        archived: true
      });

      if (response.isOK) {
        Notifications.show(this.$t("detailtask.notification.the_task_has_been_archived"));
        this.archived = true;
      } else {
        Notifications.show(response.message);
      }
    },
    async unarchiveTask() {
      var response = await storage.update("tasks", this.id, {
        archived: false
      });

      if (response.isOK) {
        Notifications.show(this.$t("detailtask.notification.the_task_has_been_unarchived"));
        this.archived = false;
      } else {
        Notifications.show(response.message);
      }
    },
    async deleteTask() {
      if (confirm(this.$t("detailtask.do_you_really_want_to_delete"))) {
        var response = await storage.delete("tasks", this.id);
        if (response.isOK) {
          await s_messaging.deleteOpenRequest(this.current_request_id);
          Notifications.show(this.$t("detailtask.notification.task_deleted"));
          this.$router.replace("/");
        } else {
          Notifications.show(response.message);
        }
      }
    },
    async getLastDone() {
      var response = await storage.get(
        "dones",
        [
          {
            column: "task_id",
            operator: "==",
            value: this.id
          }
        ],
        {
          column: "time",
          order: "desc"
        }
      );

      this.l_last_done = true;

      if (response.isOK) {
        if (response.data === undefined) {
          this.never_done = true;
          return {};
        } else {
          return response.data[0];
        }
      } else {
        Notifications.show(
          "There was an error while trying to get the last execution."
        );
      }
    },
    async markAsDone() {
      this.l_mark_as_done = true;
      var response = await storage.insert("dones", {
        task_id: this.id,
        time: new Date().getTime()
      });

      if (response.isOK) {
        Notifications.show(this.$t("detailtask.notification.marked_as_done"));
        this.never_done = false;
        await this.getNextExecution();
        await this.deleteOldRequest();
        var response_request = await s_messaging.sendRequestLater(
          JSON.stringify({
            notification: {
              title: this.name,
              description: this.description
            },
            task: {
              id: this.id
            }
          }),
          Math.round(this.next_time / 1000)
        );

        if (response_request.status === 200) {
          var response_update_request_id = await storage.update("tasks", this.id, {
            current_request_id: response_request.body.request_id
          });
          if (response_update_request_id.status === 200) {
            // Done
            this.current_request_id = parseInt(response_request.body.request_id);
          }
        }

        this.l_mark_as_done = false;

        // Reset history to show new entries
        this.loadHistory(0, 5, true);
      } else {
        Notifications.show(response.message);
      }
    },
    async markAsDoneOnSpecifcTime() {
      this.never_done = false;

      var time = (new Date(this.markAsDone_date + " " + this.markAsDone_time)).getTime();

      var response = await storage.insert("dones", {
        task_id: this.id,
        time: time
      });

      if (response.isOK) {
        Notifications.show(this.$t("detailtask.notification.marked_as_done_on", {
          date: this.markAsDone_date,
          time: this.markAsDone_time
        }));

        //Set new time if necessary
        await this.getNextExecution();
        await this.deleteOldRequest();
        var messaging_response = await s_messaging.sendRequestLater(
          JSON.stringify({
            notification: {
              title: this.name,
              description: this.description
            },
            task: {
              id: this.id
            }
          }),
          Math.round(this.next_time / 1000)
        );

        if (messaging_response.status === 200) {
          var response_update_request_id = await storage.update("tasks", this.id, {
            current_request_id: messaging_response.body.request_id
          });
          if (response_update_request_id.status === 200) {
            // Done
            this.current_request_id = parseInt(messaging_response.body.request_id);
          }
        }

        this.markAsDoneLaterStep = 1;
        this.markAsDoneLaterDialog = false;
        this.markAsDone_time = "00:00";
        this.markAsDone_date = undefined;
        this.loadHistory(0, 5, true);
      } else {
        Notifications.show(response.message);
      }
    },

    // Validation for date and time pickers
    allowedDates(val) {
      var date = new Date(val);
      return ((new Date()) - date) > 0;
    },
    allowedHours(val) {
      var today = (new Date());
      var s_today = today.getDate() + "" + today.getMonth() + "" + today.getFullYear();
      var new_val = new Date(this.markAsDone_date);
      var s_val = new_val.getDate() + "" + new_val.getMonth() + "" + new_val.getFullYear();
      if (s_today === s_val) {
        return parseInt(val) < (new Date()).getHours();
      }
      return true;
    },
    async deleteOldRequest() {
      if (this.current_request_id !== undefined) {
        var response = await s_messaging.deleteOpenRequest(this.current_request_id);
        return response.status === 200;
      }
      return false;
    },
    async deleteHistoryItem(history_id) {
      if (confirm(this.$t("detailtask.do_you_want_to_delete_history_item"))) {
        var response = await storage.delete("dones", history_id);
        if (response.isOK) {
          Notifications.show(this.$t("detailtask.notification.history_item_deleted"));
          this.loadHistory(0, 5, true);
        } else {
          Notifications.show(response.message);
        }
      }
    },
    goBack() {
      this.$router.replace("/");
    },
    parseDateTime(time) {
      var date = new Date();
      date.setTime(time);
      return (
        (date.getDate() + "").padStart(2, "0") +
        "." +
        (date.getMonth() + 1 + "").padStart(2, "0") +
        "." +
        date.getFullYear() +
        " " +
        (date.getHours() + "").padStart(2, "0") +
        ":" +
        (date.getMinutes() + "").padStart(2, "0")
      );
    }
  }
};
</script>

<style>
</style>